<template>
    <div class="container-fluid hero-banner g-0 m-0 flex-x center-y" style="align-items: flex-end;">
        <HeroItem v-show="this.active == index" v-for="(item, index) in items" :data="item" :index="index"></HeroItem>
        <div v-if="count > 1" class="container-fluid g-0 m-0 flex-x center-y d-none d-sm-none d-md-none d-lg-flex d-xl-flex" style="position: absolute; padding-bottom: 1vh;">
            <button aria-label="Change Herobanner Slide" v-for="(item, index) in items" @click="GoToItem(index)" type="button" class="btn btn-warning hero-button mx-2" :class="{ 'highlighted-hero-button' : this.active == index }" style="width: 50px;"></button>
        </div>

        <!--<div id="hero-left-button" class="mx-3 d-block d-sm-block d-md-block d-lg-none d-xl-none" style="font-size: 2em; cursor: pointer; position: absolute; left: 1vh; top: 25vh;">
            <i class="fas fa-angle-left" @click="this.PreviousItem()"></i>
        </div>

        <div id="hero-right-button" class="mx-3 d-block d-sm-block d-md-block d-lg-none d-xl-none" style="font-size: 2em; cursor: pointer; position: absolute; right: 1vw; top: 25vh;">
            <i class="fas fa-angle-right" @click="this.NextItem()"></i>
        </div>-->
    </div>
</template>

<script>

import HeroItem from './HeroItem';

export default {

    data () {
        return {
            active: 0,
	        count: 0,
            cycle: setInterval(this.NextItem, 12000)
        }
    },

    components: {
        HeroItem
    },

    props: ['items'],

    created () {
        this.count = this.items.length;
    },

    methods: {

        PreviousItem () {
            this.active--;
  		    if ( this.active < (this.count - 1) ) this.active = this.count - 1;
	    },

        NextItem () {
            this.active++;
  		    if ( this.active > (this.count - 1) ) this.active = 0;
	    },

	    GoToItem (index) {
            this.active = index;
	    }

    }

}
</script>